import { defineMessages } from 'react-intl';

export const scope = 'components.Footer';

export default defineMessages({
  titleCommon: {
    id: `${scope}.title_common`,
    defaultMessage: 'This is the Footer component!',
  },
});